import UnLockedIcon    from '../icons/UnLockedIcon';
import StaticVideoLogo from '../StaticVideoLogo/StaticVideoLogo';
import TimerBadge      from '../TimerBadge/TimerBadge';
import './footer.css';

const getBurnDownPrice = ({ base, currentMs, durationMs }) => {
  if (!Number.isFinite(base)) return null;
  if (!Number.isFinite(durationMs) || durationMs <= 0) return base;
  const clamped  = Math.min(Math.max(0, currentMs || 0), durationMs);
  const progress = clamped / durationMs;
  return Math.max(0, base * (1 - progress));
};

export default function Footer({ allAdsDone, setAllAdsDone, price, currency, currentTime, duration }) {
  const baseQap    = Number(price?.qap);
  const adjustedQap = getBurnDownPrice({ base: baseQap, currentMs: currentTime, durationMs: duration });

  return (
    <div className="footer-container">
      <div className="footer-container-inner">
        {allAdsDone ? (
          <div className="unlocked-icon">
            <UnLockedIcon />
          </div>
        ) : (
          <TimerBadge currentTime={currentTime} duration={duration} />
        )}
        <div className="footer-container-middle">
          <div className="footer-content-wrapper">
            <div className="footer-header">
              {allAdsDone ? 'Content unlocked' : 'Unlock now'}
            </div>
            <div className="footer-text">
              Enjoy instant access with ZZAZZ Pay — no waiting, no ads.
            </div>
          </div>
          {adjustedQap != null ? (
            <div className="qap">
              <span className="qap-value">{adjustedQap.toFixed(2)}</span>{' '}
              <span className="qap-label">TPC</span>
            </div>
          ) : null}
        </div>
      </div>

      {allAdsDone ? (
        <button disabled className="footer-button footer-view-now">View now</button>
      ) : (
        <button
          className="footer-button"
          onClick={() => {
            if (adjustedQap != null) localStorage.setItem('z-articlePrice', adjustedQap);
            setAllAdsDone(true);
          }}
        >
          <span className="buy-with">Buy with</span>
          <StaticVideoLogo height={32} width={32} />
          <span className="pay">Pay</span>
        </button>
      )}
    </div>
  );
}
